import { render, staticRenderFns } from "./RsaRiepilogoPresenzePage.vue?vue&type=template&id=0865bcd1&scoped=true"
import script from "./RsaRiepilogoPresenzePage.vue?vue&type=script&lang=js"
export * from "./RsaRiepilogoPresenzePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0865bcd1",
  null
  
)

export default component.exports